import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import { StaticImage } from 'gatsby-plugin-image'
import clsx from 'clsx'

import { MetaData } from '../../components/common/meta'
import Layout from '../../components/Layout'

import * as styles from './Topic.module.css'

function Tag({ data, location }) {
  const {
    ghostTag: tag,
    allGhostPost: { nodes: posts },
  } = data

  return (
    <>
      <MetaData data={data} location={location} type="series" />
      <Layout>
        <article className="page type-page status-publish hentry">
          <div className="prose lg:prose-xl">
            <div className="et_pb_section">
              <div className="et_pb_row">
                <div className="et_pb_column et_pb_column_4_4">
                  <div className="et_pb_text et_pb_bg_layout_light et_pb_text_align_left">
                    <StaticImage
                      src="../../images/icons/bulb.png"
                      alt="Lightbulb"
                      className={clsx('alignright', styles.icon)}
                      height={180}
                      objectFit="none"
                    />
                    <h2>{tag.name}</h2>
                    <p className={styles.description}>{tag.description}</p>
                    <p>&nbsp;</p>
                  </div>
                </div>
              </div>
              <div className="et_pb_row">
                <div
                  className={clsx(
                    'et_pb_text et_pb_bg_layout_light et_pb_text_align_left',
                    styles.sections,
                  )}
                >
                  <h3>Sections:</h3>
                  <ul className="lcp_catlist" id="lcp_instance_0">
                    {posts.map((post) => (
                      <li key={post.id}>
                        <Link to={`/${post.slug}`} title={post.title}>
                          {post.title}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </article>
      </Layout>
    </>
  )
}

Tag.propTypes = {
  data: PropTypes.shape({
    ghostTag: PropTypes.shape({
      name: PropTypes.string.isRequired,
      description: PropTypes.string,
    }),
    allGhostPost: PropTypes.shape({
      nodes: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string.isRequired,
          slug: PropTypes.string.isRequired,
          title: PropTypes.string.isRequired,
        }),
      ).isRequired,
    }).isRequired,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
}

export default Tag
